import React, { useState } from "react";
import styles from "./SendMessage.module.scss";
import DeleteIcon from "components/UI/Icons/Delete";
import MessageIcon from "components/UI/Icons/Sidecar/Message";
import EditIcon from "components/UI/Icons/Lines/Edit";
import { removeSidecarConfigNewTempActionList, setShowSendMessageDialogue } from "redux/sidecar/sidecarSlice";
import { useDispatch } from "react-redux";
import MoveUpDown from "components/UI/Icons/Sidecar/MoveUpDown";

const SendMessageActionCard = ({uuid, fromNumber, toNumber, message, drag, changesMade}:{uuid:string, fromNumber:string, toNumber:string, message:string, drag?:any, changesMade:()=>void}) => {
	const [editHover, setEditHover] = useState(false);
	const [deleteHover, setDeleteHover] = useState(false);
	const dispatch = useDispatch();
	return (
		<div className={styles.card} draggable onDragEnd={drag?.handlesort}  onDragEnter={()=>{drag?.dragEnter(drag)}} onDragStart={()=>{drag?.dragStart(drag)}}> 
			<p>
				{drag && <MoveUpDown />}
				<MessageIcon />
				<span>Send Message</span>
			</p>
			<p>
				<span className={styles.extension}>{toNumber}</span>
				{uuid &&
				<>
					<span className={styles.actionButton} onClick={()=>{changesMade(); dispatch(setShowSendMessageDialogue({uuid:`${uuid}`, show:true, fromNumber:fromNumber, toNumber:toNumber, message:message }))}}  onMouseOver={() => {setEditHover(true);}} onMouseOut={() => {setEditHover(false);}}><EditIcon color={editHover?"primary-default" : "icon-primary"}/></span>
					<span className={styles.actionButton} onClick={()=>{changesMade(); dispatch(removeSidecarConfigNewTempActionList(uuid))}} onMouseOver={() => {setDeleteHover(true);}} onMouseOut={() => {setDeleteHover(false);}}><DeleteIcon color={deleteHover?"support-danger-default" : "icon-primary"} /></span>
				</>}
			</p>
		</div>
	);
};

export default SendMessageActionCard;
